import { render } from "./InstructionBox.vue?vue&type=template&id=3d98b776"
import script from "./InstructionBox.vue?vue&type=script&lang=js"
export * from "./InstructionBox.vue?vue&type=script&lang=js"

import "./InstructionBox.vue?vue&type=style&index=0&id=3d98b776&lang=css"
script.render = render

export default script